import { createRpcError } from './base';

export const ensureObject = <T>(
  data: unknown,
  code: string,
  message: string,
  details?: unknown
): T => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw createRpcError(code, message, details);
  }
  return data as T;
};

export const ensureArray = <T>(
  data: unknown,
  code: string,
  message: string,
  details?: unknown
): T[] => {
  if (!Array.isArray(data)) {
    throw createRpcError(code, message, details);
  }
  return data as T[];
};
